export enum MachineryAndImplementStatus {
  FarmWorthy = 1,
  FarmWorthyafterrepaired = 2,
  TobeCondemned = 3,
  MachineryImplementNotshownduringVerification = 4
}
